import { ModulesMap } from '@/config/data/modulesMaps'

import DataTransferModule from '@/services/dataTransferModule'

import LandCategoriesApi from '@/services/apiServiceModules/landCategoriesApi.js'
const landCategoriesApi = new LandCategoriesApi()

export default class LandCategoriesDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.LAND_CATEGORIES, landCategoriesApi, {
			useCache: true,
		})
	}
}
